module.exports = __webpack_public_path__ + "img/ana_nagasaki.9fcbf72d.jpg";